var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-[#FFD602] font-semibold xl:text-[20px]"},[_vm._v("Trao thưởng")]),_c('ul',{staticClass:"flex flex-col gap-2 pl-6"},_vm._l((_vm.awardList),function(item){return _c('li',{key:item.id,staticClass:"list-disc"},[_vm._v(_vm._s(item.content))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }